import React, { useMemo } from 'react'

import { Alert, HeaderConfig, SimpleTable, TableSkeleton } from '@/components/ui'
import { formatUserDate } from '@/utils/formatDate'

import type { AlertActionsProps } from '../types'

const ALERT_ACTIONS_TABLE_HEADERS: HeaderConfig[] = ['Action Created At', 'User', 'Action', 'Note']

const AlertActions: React.FC<AlertActionsProps> = ({ rows, error, isLoading }) => {
  const tableBody = useMemo(
    () =>
      rows.map((row, index) => ({
        'Action Created At': {
          id: `action-${index}-${row.actionCreatedAt.getTime()}`,
          date: row.actionCreatedAt,
          display: formatUserDate(row.actionCreatedAt),
        },
        User: row.user ?? '-',
        Action: row.action,
        Note: row.note ?? '-',
      })),
    [rows]
  )

  return (
    <div className="alert-actions-table flex h-full min-h-0 flex-col rounded-md bg-white pt-2 pb-2 pl-4 pr-4">
      <p className="shrink-0 text-sm font-medium text-primary mb-2">Alert Actions</p>
      <div className="flex-1 min-h-0">
        {error ? (
          <Alert type="error" message={error} />
        ) : isLoading ? (
          <TableSkeleton rows={3} columns={ALERT_ACTIONS_TABLE_HEADERS.length} withHeader rowHeight={35} />
        ) : tableBody.length > 0 ? (
          <SimpleTable headers={ALERT_ACTIONS_TABLE_HEADERS} body={tableBody} />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-4 py-4">
            No actions have been taken on this alert.
          </div>
        )}
      </div>
    </div>
  )
}

export default AlertActions
